import { TipoPlanificador } from '@/shared/interfaces/erp/mantenimiento-operaciones';
import {
  FormControlLabel,
  Radio,
  Tooltip,
  TooltipProps,
  styled,
} from '@mui/material';

export type RadioButtonOptionsProps = {
  selectedTipoPlanificador: TipoPlanificador;
};

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  zIndex: theme.zIndex.tooltip + 1,
  [`& .MuiTooltip-tooltip`]: {
    fontFamily: "'Grape Nuts', Helvetica",
    backgroundColor: 'white',
    border: '1px solid #e0e0e0',
    margin: 4,
    padding: 8,
    color: 'black',
    fontSize: 14,
    fontWeight: 400,
  },
}));

const RadioButtonOptions: React.FC<RadioButtonOptionsProps> = ({
  selectedTipoPlanificador,
}) => {
  return [
    {
      value: TipoPlanificador.AUTOMATICO,
      label: 'Automático',
    },
    { value: TipoPlanificador.MANUAL, label: 'Manual' },
  ].map((option, index) => {
    const tooptipMessage =
      option.value === TipoPlanificador.AUTOMATICO
        ? 'Se generará automáticamente la planificación de una semana completa teniendo en cuenta la fecha inicial seleccionada.'
        : 'Se deberá seleccionar la fecha de inicio y fin de la planificación.';

    return (
      <StyledTooltip title={tooptipMessage}>
        <FormControlLabel
          key={index}
          value={option.value}
          control={<Radio />}
          label={option.label}
          checked={option.value === selectedTipoPlanificador}
        />
      </StyledTooltip>
    );
  });
};

export default RadioButtonOptions;
